import { Component, OnInit } from '@angular/core';
import { UserDataRequestComponent } from '../../user-data-request/user-data-request.component';
import { MatDialog } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { UtilsService } from 'src/app/core/services/utils.service';

import { NoteLegaliPopupComponent } from '../../note-legali-popup/note-legali-popup.component';
import { CookiesPopupInComponent } from '../../cookies-popup-in/cookies-popup-in.component';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  isVisible: boolean = true;
   actiaFooterText: string ;
  tenantColorClass: string;

  constructor(public dialog: MatDialog, private utilsService: UtilsService) { }

  ngOnInit(): void {
    // Al caricamento della pagina, il footer è sempre visibile
    // Rimuove eventuali flag precedenti
    sessionStorage.removeItem('footerHidden');
    this.isVisible = true;
    this.actiaFooterText = `© ${new Date().getFullYear()} ${environment.actiaFooterText}`;

    // Imposta il colore dinamico basato su tenant
    this.tenantColorClass = this.utilsService.getStylesheetString() + '-main-color';
  }

  hideFooter(): void {
    this.isVisible = false;
    // Il flag viene rimosso al prossimo refresh, quindi il footer riappare
    sessionStorage.setItem('footerHidden', 'true');
  }

  openUserDataRequestModal() {
    this.dialog.open(UserDataRequestComponent, {
      width: '90vw',
      maxWidth: '600px',
      height: 'auto',
      maxHeight: '95vh',
      disableClose: false,
      panelClass: 'user-data-request-dialog',
      data: {
        logoPath: 'assets/images/LogoNuovo_login.png'
      }
    });
  }

  openCookiesPolicy() {
    this.dialog.open(CookiesPopupInComponent, {
      width: '600px',
      disableClose: false
    });
  }




  openNoteLegali() {
    this.dialog.open(NoteLegaliPopupComponent, {
      width: '600px',
      disableClose: false
    });
  }
}
